import { P1CertificatesFormFields } from './P1CertificatesForm.types';

const P1_CERTIFICATES_FORM_BEAN_INITIAL_VALUES: P1CertificatesFormFields = {
   tlsCertificateFile: null,
   tlsCertificatePassword: null,
   wssCertificateFile: null,
   wssCertificatePassword: null,
};

export { P1_CERTIFICATES_FORM_BEAN_INITIAL_VALUES };
